import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnUA: CultureInfo = {
  name: 'en-UA',
  displayName: 'English (Ukraine)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-UA',
  parent: CultureInfoEn
};
